export {default} from "../patterngalleries/SearchResult";



// WEBPACK FOOTER //
// ./src/components/async/SearchResult.js